import React from 'react';

const Bkash = () => {
    return (
        <div>
            please pay with bkash
        </div>
    );
};

export default Bkash;